<div class="right-panel"
     *ngIf="allJoinServer.length >0">
  <div class="panel-header">
    <p class="panel-title">Add Serving Join Server for {{nsName}}</p>
  </div>
  <div class="panel-container createNS">

    <div class="createNS-row">
      <label class="widget-create-title">Join Server
        <i class="fa fa-info-circle info-text"></i>
      </label>

      <div class="live-search">
        <ngx-select [allowClear]="true"
                   [items]="allJoinServer"
                   (select)="selectedNS($event)"
                   (remove)="removed($event)">
        </ngx-select>
      </div>

    </div>

    <!--
    <div class="createNS-row" *ngIf="protocolVersion != '1.0'">
      <label class="widget-create-title">Subscriber ID
        <i class="fa fa-info-circle info-text"></i>
      </label>

      <div>
        <textarea id="subscriber_id"
                  rows="2" class="widget-create-content form-control"
                  [(ngModel)]="subscriberId"
                  name="subscriber_id"
                  #inputSubscriberId
                  autocomplete="off"
                  maxlength="80" size="80"></textarea>
      </div>
    </div>
    -->

    <div class="btn-area">
      <button (click)="backClicked()"
              class="custom-btn">Cancel
      </button>
      <button type="submit"
              class="custom-btn create-btn"
              [disabled]="!isEnable"
              [ngClass]="{'disable': !isEnable}"
              (click)="save()">Add
      </button>
    </div>
  </div>
</div>
